import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_FOZ_56 } from "@/lib/programs/fezSidialiOuarzazate56";

export default function FezSidialiOuarzazate56Page() {
  return <ProgramTemplate program={PROGRAM_FOZ_56} variant="foz" showJourneyChronology />;
}
